(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dash-category-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dash-category-carousel').forEach((section) => {
    const track = section.querySelector('[data-dash-category-track]');
    const previous = section.querySelector('[data-dash-category-prev]');
    const next = section.querySelector('[data-dash-category-next]');
    if (!track) return;
    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dash-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dash-footer').forEach((footer) => {
    const details = [...footer.querySelectorAll('.dash-footer__column')];
    const mobile = window.matchMedia('(max-width: 749px)');
    const sync = () => {
      details.forEach((item) => {
        item.open = !mobile.matches;
      });
    };
    sync();
    mobile.addEventListener('change', sync);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dash-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dash-hero-slider').forEach((section) => {
    const track = section.querySelector('[data-dash-hero-track]');
    const dots = [...section.querySelectorAll('[data-dash-hero-dot]')];
    if (!track || dots.length < 2) return;
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', () => {
      const active = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dash-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dash-product-rail').forEach((section) => {
    const track = section.querySelector('[data-dash-rail-track]');
    const previous = section.querySelector('[data-dash-rail-prev]');
    const next = section.querySelector('[data-dash-rail-next]');
    if (!track) return;
    previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .75, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .75, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
